export default __webpack_public_path__ + "static/media/Hero_Image.a53d3863.png";